import { render, staticRenderFns } from "./IconThumbsUp.vue?vue&type=template&id=d477b842"
import script from "./IconThumbsUp.vue?vue&type=script&lang=js"
export * from "./IconThumbsUp.vue?vue&type=script&lang=js"
import style0 from "./IconThumbsUp.vue?vue&type=style&index=0&id=d477b842&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports